@import (reference) '../../../../../constants/spacing.module.less';

.return-settings {
  max-width: 1280px;
}

.standard-returns-description {
  margin-bottom: @space-32;
}
